import { Suspense } from "react";

import { useIntl } from "react-intl";

import { CfLoader } from "@/shared/components/common/CfLoader/CfLoader";
import { BaseContainer } from "@/shared/containers/BaseContainer/BaseContainer";
import { usePageTitle } from "@/shared/hooks/usePageTitle";

import { Signup } from "./Signup";

const SignupWrapper = (): React.ReactElement => {
  const intl = useIntl();

  usePageTitle(intl.formatMessage({ id: "Login.dont-have-account-register" }));

  return (
    <BaseContainer>
      <Suspense fallback={<CfLoader />}>
        <Signup />
      </Suspense>
    </BaseContainer>
  );
};

export { SignupWrapper };
